import { Routes, Route } from "react-router-dom";
import Landing from "./pages/Landing";
import ConsentPage from "./pages/ConsentPage";

function App() {
    return (
        <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/consent-page" element={<ConsentPage />} />
        </Routes>
    );
}

export default App;
